import {Component, ViewEncapsulation} from '@angular/core';
import {LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from 'src/app/shared/services/api.service';
import {UserPermission} from '../../../shared/models/user';
import {FingerprintService} from '../../../shared/services/fingerprint.service';
import {QueueService} from '../../../shared/services/queue.service';
import {StorageService} from '../../../shared/services/storage.service';
import {Store} from '../../../shared/models/store';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MyAccountComponent {

  seniorityLevel: null | number;

  constructor(public nav: NavigateService,
    public api: ApiService,
    public lang: LangService,
    public queue: QueueService,
    public fingerprint: FingerprintService,
    private storage: StorageService,
    private loader: LoaderService) {
    this.seniorityLevel = this.api.checkSeniority();
  }

  changePassword() {
    if(!this.api.isOnline) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('no.connection')});
    } else if(this.api.userInfo && this.api.userInfo.accountName.toLowerCase().includes(this.api.userInfo.server.domain)) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('change.password.ad')});
    } else {
      this.nav.to('change-password');
    }
  }

  history() {
    if(this.api.isOnline) {
      this.nav.to('payment-commandHistory');
    } else {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('no.connection')});
    }
  }

  wip() {
    this.loader.loading(true, {type: 'warn', message: 'WIP'}).then(() => {
      this.nav.to('my-account');
    });
  }

  disconnect() {
    this.loader.loading(true, {type: 'warn', message: 'ask.disconnect', btnLabel: 'global.yes'}).then((done) => {
      if(done) {
        this.api.signOut();
      }
    });
  }

  openMailto() {
    window.location.href = `mailto:${this.api.env.supportContactEmail}`;
  }

  clearStorage() {
    this.loader.loading(true, {type: 'error', btnLabel: 'global.yes', custom: {icon: 'recycle', innerHtml: this.lang.transform('ask.clear.storage')}}).then((done) => {
      if(done) {
        this.loader.loading(true);
        this.queue.exportQueueToJSON(false);
        setTimeout(() => {
          this.queue.stop();
          this.storage.idbstorage?.close();
          window.indexedDB.deleteDatabase('lu.satoris.paycode');
          window.localStorage.clear();
          window.sessionStorage.clear();
          this.loader.loading(false);
          window.location.reload();
        }, 1000);
      }
    });
  }

  downloadLogs() {
    this.storage.downloadCompleteStoreAsJSON(Store.LOGS_STORE);
  }

  protected readonly UserPermission = UserPermission;
}


